(function () {
  var RESET_DELAY = 2000;

  function showMessage(button, text) {
    var card = button.closest('.snippet-product-grid');
    var target = card ? card.querySelector('.grid-quickshop-msg') : null;
    if (!target || !text) return;
    target.textContent = text;
    target.classList.add('is-visible');
    setTimeout(function () {
      target.textContent = '';
      target.classList.remove('is-visible');
    }, RESET_DELAY);
  }

  function withinStockCap(button) {
    var maxQty = parseInt(button.getAttribute('data-max-qty'), 10);
    var variantId = button.getAttribute('data-variant-id');
    if (isNaN(maxQty) || !variantId) return Promise.resolve({ ok: true });
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var current = 0;
        (cart.items || []).forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) current += item.quantity;
        });
        return { ok: current + 1 <= maxQty, message: button.getAttribute('data-max-message') };
      })
      .catch(function () { return { ok: true }; });
  }

  function refreshCart() {
    if (document.location.href.indexOf('/cart') > -1 && window.jQuery) {
      window.jQuery('.cart-wrap').load('/cart .cart-wrap .cart-section', function () {
        window.history.pushState({}, null, '/cart');
      });
      return;
    }
    if (typeof load_cart !== 'function') {
      window.location.href = '/cart';
      return;
    }
    var refreshed = load_cart();
    var openDrawer = function () {
      document.querySelector('body').classList.add('open-drawer');
      document.querySelector('body').classList.remove('open-menu', 'open-search', 'open-sort', 'open-filter', 'open-wishlist');
    };
    if (refreshed && typeof refreshed.then === 'function') {
      refreshed.then(openDrawer).catch(openDrawer);
    } else {
      setTimeout(openDrawer, 500);
    }
  }

  function confirmAdded(button) {
    button.classList.add('is-added');
    setTimeout(function () {
      button.classList.remove('is-added');
    }, RESET_DELAY);
  }

  function addToCart(button) {
    button.classList.add('is-loading');
    button.setAttribute('disabled', 'disabled');

    var release = function () {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    };

    withinStockCap(button).then(function (cap) {
      if (!cap.ok) {
        release();
        showMessage(button, cap.message);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.getAttribute('data-variant-id'), quantity: 1 }] })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          release();
          if (data.status) {
            showMessage(button, data.description || data.message);
            return;
          }
          confirmAdded(button);
          refreshCart();
        })
        .catch(function (error) {
          release();
          console.error('Quick shop:', error);
        });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.grid-quickshop') : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.hasAttribute('disabled')) return;
    addToCart(button);
  });
})();
